import { useCallback, useState } from 'react';
import { CALENDAR_VIEW, DEPARTING, LIST_VIEW, RETURNING } from './constants';
import tracking from '@g4/g4-analytics';
import { useRouter } from 'next/router';
import moment from '@g4/moment-utc';

const useViewToggle = ({
  tabDates,
  setDepartingTabs,
  setReturningTabs,
  backupTabDate,
  setBackupTabDate,
}) => {
  const { query = {} } = useRouter();
  const initialView = query.sc === undefined ? LIST_VIEW : CALENDAR_VIEW;

  const [view, setView] = useState({
    [DEPARTING]: initialView,
    [RETURNING]: initialView,
  });

  // Callback for the toggle between list and calendar views
  const handleViewToggle = useCallback(
    (newView, leg, onclick = false) => {
      if (newView !== LIST_VIEW) {
        //we need see a back up of the old date
        setBackupTabDate(prev => ({
          ...prev,
          [leg]: tabDates[leg]?.middle,
        }));
        const viewingMoment = moment(tabDates[leg].middle);
        const viewingMonth = viewingMoment.month();
        const selectedMoment = tabDates[leg].selected
          ? moment(tabDates[leg].selected)
          : viewingMoment;
        const selectedMonth = selectedMoment.month();
        if (viewingMonth !== selectedMonth) {
          leg !== RETURNING
            ? setDepartingTabs({ middle: selectedMoment.format('YYYY-MM-DD') })
            : setReturningTabs({ middle: selectedMoment.format('YYYY-MM-DD') });
        }
      } else {
        if (backupTabDate[leg] && leg === DEPARTING && !onclick) {
          setDepartingTabs({ middle: backupTabDate[DEPARTING] });
        }

        if (backupTabDate[leg] && leg === RETURNING && !onclick) {
          setReturningTabs({ middle: backupTabDate[RETURNING] });
        }
      }

      setView(prev => ({
        ...prev,
        [leg]: newView,
      }));

      tracking.trackEvent(
        'site_click_tracking',
        'Flight Chooser',
        `${newView === CALENDAR_VIEW ? 'Rate Calendar' : 'List View'} | ${
          query.d
        }`,
        null
      );
    },
    [
      setView,
      query,
      tabDates,
      setReturningTabs,
      setDepartingTabs,
      setBackupTabDate,
      backupTabDate,
    ]
  );

  return {
    view,
    handleViewToggle,
  };
};

export default useViewToggle;
